import { render, staticRenderFns } from "./SelectMergeSurvivorModal.vue?vue&type=template&id=27b4b9ac"
import script from "./SelectMergeSurvivorModal.ts?vue&type=script&lang=ts&external"
export * from "./SelectMergeSurvivorModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b4b9ac')) {
      api.createRecord('27b4b9ac', component.options)
    } else {
      api.reload('27b4b9ac', component.options)
    }
    module.hot.accept("./SelectMergeSurvivorModal.vue?vue&type=template&id=27b4b9ac", function () {
      api.rerender('27b4b9ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Pages/TransactionManagement/List/Components/SelectMergeSurvivorModal.vue"
export default component.exports